import React, { useState, useEffect } from 'react';
import OkCancelModal from './OkCancelModal';

const UnsavedFromDataAlertModel = () => {
    const [modalVisible, setModalVisible] = useState(false);
    
    const handleConfirm = () => {
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    return (
        <>
            <OkCancelModal
                isOpen={modalVisible}
                header="Warning"
                body="You have unsaved data. Do you want to exit without saving?"
                okText="Yes"
                cancelText="No"
                okFunction={handleConfirm}
                cancelFunction={handleCancel}
            />
        </>
    );
};

export default UnsavedFromDataAlertModel;
